import React from "react";
import {TextField} from "@material-ui/core";
import {maxContextLength} from "./use_client_context_editor";

const counterThreshold = maxContextLength * 0.9;

interface ContextTextAreaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const ContextTextArea: React.FC<ContextTextAreaProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  const isOverLimit = value.length > maxContextLength;
  const helperText = isOverLimit
    ? `Context must be at most ${maxContextLength} characters`
    : value.length > counterThreshold
    ? `${value.length}/${maxContextLength}`
    : undefined;

  return (
    <TextField
      placeholder={placeholder}
      multiline
      fullWidth
      rows={8}
      rowsMax={16}
      variant="outlined"
      value={value}
      onChange={e => onChange(e.target.value)}
      error={isOverLimit}
      helperText={helperText}
    />
  );
};

export default ContextTextArea;
